import React from 'react';
import {withCore} from 'frontend-core';
import {renderRoutes} from 'react-router-config';
import {BrowserRouter} from 'react-router-dom';
import {Loader} from 'frontend-core';
import {CustomRouteConfig} from 'frontend-core/build/components/sidebar/sidebar';
import {ChangeRoutes} from 'frontend-core/build/components/core/core';

import {createRoutes} from '../router';
import {Theme} from '../contexts/theme';

import Keycloak from 'keycloak-js';
import {ViewModeContext} from '../contexts/viewMode';

import {ViewMode} from '../models/viewMode';

interface Props {
  routes: CustomRouteConfig[];
  changeTheme: (name: string) => void;
}

export interface AppState {
  moduleRoutes: CustomRouteConfig[];
  title: string;
  user?: {
    info?: object;
    kc: Keycloak.KeycloakInstance;
  };
  viewMode: ViewMode;
}

export default class App extends React.Component<any, AppState> {
  constructor(props: any) {
    super(props);

    const viewMode = (localStorage.getItem('viewMode') as ViewMode) || ViewMode.BASE;

    this.state = {
      moduleRoutes: [],
      title: '',
      viewMode: viewMode
    };
    localStorage.setItem('viewMode', viewMode);
  }

  componentDidMount(): void {
    fetch('/config.json')
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          moduleRoutes: data.routes
        });

        if (data.keycloak) {
          this.initKeycloak(data.keycloak);
        }

        if (data.title) {
          this.setState({title: data.title});
          document.title = data.title;
        }
      });
  }

  /**
   * Обновление токенов keycloak в localStorage
   */
  updateLocalStorage = (keycloak: any) => {
    localStorage.setItem('kc_token', keycloak.token);
    localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
  };

  changeRoutes: ChangeRoutes = (componentName, routes) => {
    const {moduleRoutes} = this.state;
    const newModuleRoutes = moduleRoutes.map((moduleRoute) => {
      const newModuleRoute = {...moduleRoute};
      if (newModuleRoute.componentName === componentName) {
        newModuleRoute.routes = routes;
      }
      return newModuleRoute;
    });

    this.setState({
      moduleRoutes: newModuleRoutes
    });
  };

  /**
   * Инициализация keycloak
   * @param config
   */
  initKeycloak = (config?: string | {}) => {
    const kc: any = Keycloak(config);

    kc.init({onLoad: 'login-required'})
      .success((authenticated: any) => {
        console.log('authenticated', authenticated);

        if (authenticated) {
          this.updateLocalStorage(kc);

          this.setState({
            user: {
              kc: kc
            }
          });

          setInterval(() => {
            kc.updateToken(11)
              .success((refreshed: any) => {
                if (refreshed) {
                  this.updateLocalStorage(kc);
                } else {
                }
              })
              .error(() => kc.logout());
          }, 10000);

          // kc.loadUserProfile()
          //   .success((profile: any) => {
          //     alert(JSON.stringify(profile, null, '  '));
          //   })
          //   .error(() => {
          //     alert('Failed to load user profile');
          //   });
        } else {
          console.log('kc.login()');
          // kc.login();
        }
      })
      .error(() => {
        console.log('init error');
        console.log('kc.login()');
        // kc.login();
      });
  };

  changeViewMode = (viewMode: ViewMode) => {
    localStorage.setItem('viewMode', viewMode);
    this.setState({viewMode});
  };

  render() {
    const {moduleRoutes, title, user, viewMode} = this.state;
    if (moduleRoutes.length > 0 && user) {
      const CoreApp = withCore(
        (props: Props) => {
          const {routes, changeTheme} = props;
          return (
            <ViewModeContext.Provider
              value={{viewMode: viewMode, changeViewMode: this.changeViewMode}}
            >
              <Theme.Provider value={{changeTheme: changeTheme, title: title}}>
                <BrowserRouter>
                  {routes.length ? renderRoutes(routes) : <div>Not routes</div>}
                </BrowserRouter>
              </Theme.Provider>
            </ViewModeContext.Provider>
          );
        },
        createRoutes(moduleRoutes, user),
        this.changeRoutes
      );
      return <CoreApp />;
    } else {
      return <Loader />;
    }
  }
}
